import * as React from "react";
import { memo } from "react";
import { useSelector } from "react-redux";
import { MoneyType } from "../../../../api/api";
import { useStaticContext } from "../../../../core";
import { E2EIdentifier } from "../../../../core/e2e/E2EIdentifier";
import {
  formatCash,
  formatCashAmount,
  formatCashLabel,
  formatCoins,
  formatCoinsLabel
} from "../../../../core/utils/formatters";
import { IState } from "../../../redux";
import {
  DisplayDesktopDefault,
  DisplayDesktopMinimal,
  IDisplayDesktopProps
} from "./Display";

const wrapper = (
  TheGenericDisplay: React.FunctionComponent<IDisplayDesktopProps>
) => {
  const { language } = useStaticContext();

  const winInCoins = useSelector((state: IState) => state.money.winInCoins);
  const winInCash = useSelector((state: IState) => state.money.winInCash);
  const moneyType = useSelector((state: IState) => state.money.moneyType);
  const currencyFormat = useSelector(
    (state: IState) => state.money.currencyFormat
  );

  const isCash = moneyType === MoneyType.CASH;

  const label = isCash
    ? formatCashLabel(language.Win.toUpperCase(), currencyFormat)
    : formatCoinsLabel(language.Win.toUpperCase(), "");

  const value = isCash
    ? formatCash(winInCash, currencyFormat)
    : formatCoins(winInCoins, currencyFormat);

  const childValue = formatCashAmount(winInCash, currencyFormat);

  const dataE2EId = E2EIdentifier.DESKTOP_KEYPAD_WIN;

  const props: IDisplayDesktopProps = {
    label,
    value,
    childValue,
    isCash,
    dataE2EId
  };
  return <TheGenericDisplay {...props} />;
};

export const WinDisplayDesktopDefault = memo(
  function WinDisplayDesktopDefault() {
    return wrapper(DisplayDesktopDefault);
  }
);

export const WinDisplayDesktopMinimal = memo(
  function WinDisplayDesktopMinimal() {
    return wrapper(DisplayDesktopMinimal);
  }
);
